import React, { FC, useContext } from 'react';
import { FlightSearch } from 'ts/flight/interfaces/FlightSearch';
import FlightTicket from './FlightTicket';
import { FlightsResultContext } from 'contexts/FlightsResultContext';
import { useTranslation } from 'react-i18next';
import { RoundTripMode } from 'constants/flight';
import withErrorBoundary from 'components/shared/withErrorBoundary';

interface FlightResultListProps {
  flights: FlightSearch[];
  sessionStorageKey: string;
}

const FlightResultList: FC<FlightResultListProps> = ({ flights, sessionStorageKey }) => {
  const [t] = useTranslation();
  const flightContext = useContext(FlightsResultContext);

  return (
    <div className="flight-tickets">
      {flightContext?.roundTripMode === RoundTripMode.Inbound && (
        <div className="title">{t('flight.inbound')}</div>
      )}
      {flightContext?.roundTripMode === RoundTripMode.Outbound && (
        <div className="title">{t('flight.outbound')}</div>
      )}
      {flights.map((flight) => (
        <FlightTicket flight={flight} key={flight.id} sessionStorageKey={sessionStorageKey} />
      ))}
    </div>
  );
};

export default withErrorBoundary(FlightResultList, 'FlightResultList');
